let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6dvCu")).then(() => parcelRequire('8ulLA'));